/**
 * Shared card styling constants for GenericSelectorDropdown and GenericSliderDropdown
 */

export const CARD_DEFAULT_CLASSNAMES = 'flex flex-row flex-1 w-full';

// ============================================================================
// Layout Patterns
// ============================================================================

export const FLEX_CONTAINER = 'flex-1 min-w-0'; // Flexible container that can shrink
export const FLEX_ROW_CENTER = 'flex flex-row items-center'; // Horizontal flex with vertical centering
export const FLEX_COL = 'flex flex-col'; // Vertical flex container
export const FIXED_SIZE = 'flex-shrink-0'; // Fixed size item that won't shrink

// ============================================================================
// Card Base Styling
// ============================================================================

export const CARD_BORDER = 'border border-wb-border'; // Standard card border
export const CARD_BG_CLOSED =
  'bg-[light-dark(var(--moon-100),var(--moon-850))] hover:bg-[light-dark(var(--moon-150),var(--moon-800))]'; // Closed card background
export const CARD_BG_OPEN = '!bg-wb-surface'; // Open card background
export const CARD_HEIGHT = 'h-[50px]'; // Fixed card height (50px total including 1px borders top/bottom)
export const CARD_MIN_WIDTH = 'min-w-[60px]'; // Minimum card width when closed
export const CARD_PADDING = 'px-8'; // Standard horizontal padding (vertical centering handled by flex)
export const CARD_ROUNDED = 'rounded-md'; // Standard card border radius
export const CARD_HOVER =
  'hover:border-[light-dark(var(--moon-400),var(--moon-550))] hover:shadow-sm'; // Hover effects
export const CARD_TRANSITION = 'transition-all'; // Smooth transitions

// ============================================================================
// Card States
// ============================================================================

// When card is closed
export const CARD_CLOSED = [
  'group cursor-pointer',
  CARD_HEIGHT,
  CARD_MIN_WIDTH,
  CARD_BG_CLOSED,
  CARD_HOVER,
  CARD_ROUNDED,
  CARD_TRANSITION,
].join(' ');

// When card is open (bottom placement)
export const CARD_OPEN_BOTTOM = [
  CARD_HEIGHT,
  CARD_BG_OPEN,
  CARD_BORDER,
  '!border-wb-border',
  '!border-b-transparent',
  '!rounded-b-none',
  'shadow-none',
].join(' ');

// When card is open (top placement)
export const CARD_OPEN_TOP = [
  CARD_HEIGHT,
  CARD_BG_OPEN,
  CARD_BORDER,
  '!border-wb-border',
  '!border-t-transparent',
  '!rounded-t-none',
  'shadow-none',
].join(' ');

// ============================================================================
// Menu/Popover Styling
// ============================================================================

export const MENU_BASE = 'bg-wb-surface border border-wb-border z-50';
export const MENU_BOTTOM = 'border-t-0 rounded-b-md'; // Menu opens below
export const MENU_TOP = 'border-b-0 rounded-t-md'; // Menu opens above

// ============================================================================
// Positioning
// ============================================================================

export const ABSOLUTE_OVERLAY = 'absolute left-0 right-0'; // Full-width absolute positioned overlay
export const Z_CONTROL_OPEN = 'z-[100]'; // Control container when menu is open
